export enum VehicleLookupStatusTypes {
  Success = 0,
  CapNotFound = 1,
  VehicleNotFound = 2,
  TimedOut = 3,
  Error = 4
}

